





























import { Component, Prop, Vue } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { unitTimezone } from '@/_utils/datetime'
import GeofenceMessage from '@/_interfaces/GeofenceMessage'

@Component({
  components: {},
})
export default class MessageItem extends Vue {
  @Prop() message!: GeofenceMessage

  get messageType() {
    return this.message && this.message.geo_bg_class ? 'is-' + this.message.geo_bg_class.trim() : ''
  }

  parseTime(time: any) {
    const unixTime = moment(new Date(time)).unix()
    return moment.unix(unixTime).fromNow()
  }

  parseToDateTime(time: any) {
    const format = 'YYYY-MM-DD HH:mm:ss'
    return moment(time).tz(unitTimezone()).format(format)
  }
}
